var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1152,
    zoomAndPan: "magnify",
    viewBox: "0 0 864 863.999991",
    height: 1152,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7768f38b09"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 35.292969 35.292969 L 828.707031 35.292969 L 828.707031 828.707031 L 35.292969 828.707031 Z M 35.292969 35.292969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "89fbc2bf29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 432 35.292969 C 212.902344 35.292969 35.292969 212.902344 35.292969 432 C 35.292969 651.097656 212.902344 828.707031 432 828.707031 C 651.097656 828.707031 828.707031 651.097656 828.707031 432 C 828.707031 212.902344 651.097656 35.292969 432 35.292969 Z M 432 35.292969 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a96c095bb8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 193 221.8125 L 671 221.8125 L 671 641.8125 L 193 641.8125 Z M 193 221.8125 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7768f38b09)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#89fbc2bf29)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M 35.292969 35.292969 L 828.707031 35.292969 L 828.707031 828.707031 L 35.292969 828.707031 Z M 35.292969 35.292969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a96c095bb8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#111931",
    d: "M 632.488281 260.1875 C 607.730469 235.429688 574.800781 221.789062 539.792969 221.789062 C 504.78125 221.789062 471.851562 235.421875 447.105469 260.1875 L 432.054688 275.214844 L 417.019531 260.179688 C 392.261719 235.421875 359.339844 221.78125 324.320312 221.78125 C 289.304688 221.78125 256.382812 235.410156 231.625 260.179688 C 180.511719 311.292969 180.511719 394.453125 231.625 445.570312 L 425.550781 639.496094 C 427.34375 641.289062 429.699219 642.191406 432.054688 642.191406 C 434.414062 642.191406 436.769531 641.289062 438.5625 639.496094 L 632.488281 445.570312 C 683.601562 394.464844 683.601562 311.292969 632.488281 260.1875 Z M 632.488281 260.1875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.c9a7ce0546108fb45a719f18f990a4bb.svg";
export { ForwardRef as ReactComponent };